/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import {
	BP,
	ISchemaFlowNodeTypeOutputDefinitionMap,
	SCHEMA_CONST_ANY_VALUE_TYPE,
	TGetBlueprintSchemaSpec
} from "@adapptio/lib-blueprint";
import { NODE_TYPES } from "./BlueprintNode";
import { termsEditor } from "../../terms";

export const BlueprintOutputNode = {
	name: NODE_TYPES.RETURN,
	label: "Return",
	icon: "mdi/export",
	editorOptions: {
		displayInPalette: true
	},
	opts: BP.Object({
		label: termsEditor.nodes.common.options.label,
		description: termsEditor.nodes.common.options.description,
		props: {
			value: BP.Prop(
				BP.Any({
					label: termsEditor.nodes.output.value.label,
					description: termsEditor.nodes.output.value.description,
					defaultType: SCHEMA_CONST_ANY_VALUE_TYPE.STRING
				})
			)
		},
		editorOptions: {
			layoutType: "passthrough"
		}
	}),
	resolveOutputs: (): ISchemaFlowNodeTypeOutputDefinitionMap => ({})
};

export type TBlueprintOutputNodeOptsSchemaSpec = TGetBlueprintSchemaSpec<typeof BlueprintOutputNode["opts"]>;
